/**
 * Query hooks for fixture-type articles.
 */
import { queryOptions, useQuery } from "@tanstack/react-query"
import { bomQueryKeys } from "@/lib/queryKeys"
import { listFixtureTypeArticlesFn } from "../server/fixtureTypeArticles"

export function fixtureTypeArticlesQueryOptions(configVersionId: string) {
  return queryOptions({
    queryKey: bomQueryKeys.fixtureTypeArticles(configVersionId),
    queryFn: () => listFixtureTypeArticlesFn({ data: { configVersionId } }),
    enabled: !!configVersionId,
  })
}

export function useFixtureTypeArticles(configVersionId: string) {
  return useQuery(fixtureTypeArticlesQueryOptions(configVersionId))
}
